export const getWebsocket = (state: any) => state.websocket;
